import { IonGrid, IonRow, IonCol } from "@ionic/react";
import { useSelector } from "react-redux";
import { selectSegmentSelected } from "../../../store/templateDetail/selectors/selectSegmentSelected";
import { AddQuestionButton } from "./AddQuestionButton";
import { TemplateInputsContainer } from "./TemplateInputsContainer";

export const TemplateFormContainer = () => {
  const segmentSelected = useSelector(selectSegmentSelected);

  return (
    <>
      {segmentSelected === "form" && (
        <IonGrid>
          <IonRow>
            <IonCol>
              <AddQuestionButton />
              <TemplateInputsContainer />
            </IonCol>
          </IonRow>
        </IonGrid>
      )}
    </>
  );
};
